import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import Dialog from '@src/App/Components/Dialogs/Dialog/Dialog';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';
import './CategorizeDialog.css';
import { BoxButton, BoxButtons } from '@src/App/Components/Buttons/BoxButton/BoxButton';
import { useDialog } from '@src/App/Components/Dialogs/DialogManager';
import { CategorizeDialog } from './CategorizeDialog';
import { CreateCategorizationDialog } from './CreateCategorizationDialog';

interface CategorizeDialogMainProps {
    id: string;
    resolve: () => void;
}
/**
 * CategorizeDialog component.
 *
 * @param {CategorizeDialogMainProps} close - The props for closing the dialog.
 * @returns {JSX.Element} The rendered dialog element.
 */
function CategorizeDialogMain({ id, resolve: close }: CategorizeDialogMainProps) {
    const { openDialog } = useDialog();

    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).categorizeDialog;

    return (
        <Dialog
            id={id}
            title={langStrings.dialogTitle}
            onClose={(): void => {
                close();
            }}
        >
            <BoxButtons>
                <BoxButton
                    title={langStrings.suggestCategoriesTitle}
                    description={langStrings.suggestCategoriesDescription}
                    onClick={() => {
                        openDialog(<CreateCategorizationDialog id="CreateCategorizationDialog" />);
                    }}
                />
                <BoxButton
                    title={langStrings.suggestCategorisationTitle}
                    description={langStrings.suggestCategorisationDescription}
                    onClick={() => {
                        openDialog(<CategorizeDialog id="CategorizeDialog" />);
                    }}
                />
            </BoxButtons>
        </Dialog>
    );
}
export default CategorizeDialogMain;
